import { Adapter } from '@mode-switch/adapt';
import { Ident } from '@mode-switch/express';
import { Query } from './Query';
export var RecordsPlan;
(function (RecordsPlan) {
    function make(adapter, model, viewName, query) {
        const { fields, filters, detail, sorts, limit, offset } = query;
        const source = 'SUM(1)';
        const attrType = "CONTINUOUS";
        const count = Adapter.Fields.make(adapter, model, viewName, source, attrType, {
            alias: 'count',
        });
        const id = Ident.next();
        return {
            type: "RECORDS",
            id,
            model,
            viewName,
            queries: [
                Query.Pivot.make({
                    name: 'count',
                    marks: [count],
                    filters,
                    detail,
                }),
                Query.Table.make({
                    name: 'records',
                    fields,
                    filters,
                    detail,
                    sorts,
                    limit,
                    offset,
                }),
            ],
        };
    }
    RecordsPlan.make = make;
})(RecordsPlan || (RecordsPlan = {}));
